import Header from "../navigation/header";
import {
  StyleSheet,
  TouchableOpacity,
  ScrollView,
  Switch,
  Modal,
  TextInput as TextInputRn,
  Dimensions,
} from "react-native";
import { Text, View } from "../../../components/Themed";
import { jsonToCSV } from "react-native-csv";

import { RootStackScreenProps } from "../../../types"; // @ts-ignore
import React, { useEffect, useState } from "react";
import Icon from "react-native-vector-icons/AntDesign";

import { useFocusEffect } from "@react-navigation/native";
import { postData } from "../../../networking/api";
import { TextInput } from "react-native-paper";
import { Provider as PaperProvider } from "react-native-paper";
// import { DataTable } from "react-native-paper";
import DataTable from "react-data-table-component";

import IconEdit from "react-native-vector-icons/FontAwesome";
import IconCross from "react-native-vector-icons/Entypo";
import IconEye from "react-native-vector-icons/Entypo";
import AsyncStorage from "@react-native-async-storage/async-storage";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { ActivityIndicator } from "react-native";

export default function ProjectProfile({ navigation }) {
  const [text, setText] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  var [counter, setCounter] = useState(1);

  const [mobileNumber, setMobileNumber] = useState("");
  const [mobileNumberValid, setMobileNumbervalid] = useState(true);

  const [isLoading, setIsLoading] = useState(false);
  const [ProjectDataLength, setProjectDataLength] = useState(0);

  const [searchData, setSearch] = useState("");
  const [ProjectNameData, setProjectNameData] = useState([]);
  const [projectListExport, setProjectListExport] = useState([]);

  const [filterData, setFilteredDataSource] = useState([]);
  const [isProjectNameDataValid, setProjectNameDataValid] = useState(false);
  const [isProjectNameDataEntered, setProjectNameDataEntered] = useState(false);
  const [sort, setsort] = useState(0);

  const [editpopup, setEditPopup] = useState(false);
  const [popid, setpopid] = useState("");
  const [popindex, setpopindex] = useState("");
  const [editInput, setEditInput] = useState(false);

  const [mobileNumError, setMobileNumError] = useState("");

  // DATATABLE PROJECT TYPE COLUMN AND STYLE
  const customStyles = {
    rows: {
      style: {
        // maxWidth: 50,
        minHeight: "30px", // override the row height
      },
    },
    headRow: {
      style: {
        borderTopStyle: "solid",
        borderTopWidth: "1px",
        backgroundColor: "#319ef0a3",
        minHeight: "40px",
        fontSize: 16,
        fontWeight: "600",
      },
    },
    headCells: {
      style: {
        // paddingLeft: '8px', // override the cell padding for head cells
        // paddingRight: '8px',
        justifyContent: "center",
        minHeight: "20px",

        // borderRightWidth: 2,
        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
          // fontSize: 16,
          // fontWeight: '600',
          // borderRightColor: defaultThemes.default.divider.default,
        },
      },
    },
    cells: {
      style: {
        paddingLeft: "8px", // override the cell padding for data cells
        paddingRight: "8px",
        justifyContent: "center",

        "&:not(:last-of-type)": {
          textTransform: "Capitalize",
          borderRightStyle: "solid",
          borderRightWidth: "1px",
          fontSize: 16,
          fontWeight: "400",
          // borderRightColor: defaultThemes.default.divider.default,
        },
      },
    },
  };
  const caseInsensitiveSort = (rowA, rowB) => {
    const a = rowA.project_name.toLowerCase();
    const b = rowB.project_name.toLowerCase();

    if (a > b) {
      return 1;
    }

    if (b > a) {
      return -1;
    }

    return 0;
  };
  const columns = [
    {
      name: "Sr.No",
      selector: (row) => row.index,
      //cell: (row, index) => index + 1,
      // sortable: true,
      width: "100px",
    },
    {
      name: "Project Name",
      selector: (row: any) => row.project_name,
      sortFunction: caseInsensitiveSort,
      sortable: true,
    },
    {
      name: "Project Type",
      selector: (row) => row.project_type.type,
      sortable: true,
    },
    {
      name: "Contractor",
      selector: (row) => row.contractor,
      sortable: true,
    },
    {
      name: "Omega Name",
      //  selector: "devices_master.device_name" === null ? "" : "devices_master.device_name",
      // selector: "project_devices[]" == null ? "project_devices[0].devices_master.device_name" : null,
      // selector: (row) =>
      //   row.project_devices.length > 0 ?
      //     (row.project_devices[0].devices_master === null ? " " : row.project_devices[0].devices_master.device_name)

      //     : ""
      // ,
      selector: (row) =>
        row.project_devices.length > 0
          ? row.project_devices[0].devices_master === null
            ? "NA"
            : row.project_devices[0].devices_master.device_name
          : "NA",
      sortable: true,
    },
    {
      name: "Project Details",
      selector: (row) => row.project_details,
      sortable: true,
      width: "150px",
    },
    {
      name: "Client",
      selector: (row) => row.client,
      sortable: true,
    },
    {
      name: "Action",
      // selector: "country",
      width: "100px",

      // sortable: true
      cell: (item) => (
        <View style={{ flexDirection: "row" }}>
          <TouchableOpacity
            style={{ marginRight: 10 }}
            onPress={() => {
              navigation.navigate("EditProjectProfile", {
                Projects_Id: item.id,
              });
            }}
          >
            <IconEdit
              name="pencil"
              size={13}
              color="#fff"
              style={{
                padding: 6,
                backgroundColor: "#08588E",
                borderRadius: 12,
              }}
            />
          </TouchableOpacity>

          <TouchableOpacity
            onPress={() => {
              navigation.navigate("ViewProjectProfile", {
                Projects_Id: item.id,
              });
            }}
            style={{ marginRight: 10 }}
          >
            <IconEye
              name="eye"
              size={13}
              color="#fff"
              style={{
                padding: 6,
                backgroundColor: "#08588E",
                borderRadius: 12,
              }}
            />
          </TouchableOpacity>
        </View>
      ),
    },
    {
      name: "Status",
      width: "100px",

      cell: (item, index) => (
        <Switch
          // disabled={true}
          trackColor={{ false: "#767577", true: "#1DA1F2" }}
          thumbColor={item.active == 1 ? "#fff" : "#f4f3f4"}
          activeThumbColor="#fff"
          onValueChange={() => {
            setEditPopup(true);
            setpopid(item.id);
            setpopindex(index);
          }}
          value={item.active == 1 ? true : false}
        />
      ),
    },
  ];

  const toggleSwitch = () => {
    var tempIndex = ProjectNameData.findIndex((item) => item.id === popid);

    if (ProjectNameData[tempIndex].active == 1) {
      ProjectNameData[tempIndex].active = 0;
      activeProject(popid, 0);
    } else {
      ProjectNameData[tempIndex].active = 1;
      activeProject(popid, 1);
    }
    setProjectNameData(ProjectNameData);
  };

  const regex = /^[0-9]*$/;

  //Pagination
  const optionsPerPage = [10, 25, 50, 100];

  const [page, setPage] = React.useState(0);
  const [itemsPerPage, setItemsPerPage] = React.useState(optionsPerPage[0]);
  const from = page * itemsPerPage;
  const to = Math.min((page + 1) * itemsPerPage, ProjectDataLength);
  React.useEffect(() => {
    setPage(0);
    setpopindex("");
    setEditPopup(false);
    setpopid("");
  }, [itemsPerPage]);

  useFocusEffect(
    React.useCallback(() => {
      getAllProjectData([]);
      // getProjectListForExport();
      // searchFilterFunction("");
    }, []),
  );

  const searchFilterFunction = (text) => {
    // Check if searched text is not blank
    if (text) {
      // Inserted text is not blank
      // Filter the masterDataSource
      // Update FilteredDataSource
      const newData = ProjectNameData.filter(function (item) {
        const itemData = item.project_name
          ? item.project_name.toUpperCase()
          : "".toUpperCase();
        const textData = text.toUpperCase();
        return itemData.indexOf(textData) > -1;
      });
      setFilteredDataSource(newData);
      setSearch(text);
      setPage(0);
    } else {
      // Inserted text is blank
      // Update FilteredDataSource with masterDataSource
      setFilteredDataSource(ProjectNameData);
      setSearch(text);
      setPage(0);
    }
  };
  //isActive Project profile
  const activeProject = async (ppId, isActive) => {
    setIsLoading(true);
    try {
      var ProjectData = JSON.stringify({
        id: ppId,
        module: "project",
        data: {
          active: isActive,
        },
      });
      const activeProjectResponse = await postData(
        ProjectData,
        "masters/masterCreateUpdate",
      );

      setIsLoading(false);

      var code = activeProjectResponse.code;
      if (code == 1) {
        // //alert(activeProjectResponse.message);
        setIsVisible(false);
        getAllProjectData([]);
        getProjectListForExport();
      } else {
        setIsLoading(false);
        // //alert(activeProjectResponse.message);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error", error);
    }
  };
  const exportCsvProjectData = async () => {
    setIsLoading(true);
    try {
      var getProjectData = JSON.stringify({
        module: "farmer_master",
      });
      const ProjectNameResponse = await postData(
        getProjectData,
        "masters/exportFile",
      );
      setIsLoading(false);
      var code = ProjectNameResponse.code;
      if (code == 1) {
        // setProjectDataLength(ProjectNameResponse.data.length);
        setProjectNameData(ProjectNameResponse.data);
        // setFilteredDataSource(ProjectNameResponse.data)
        // const results = jsonToCSV(ProjectNameResponse.data);
      } else {
        setIsLoading(false);
        //alert(ProjectNameResponse.message);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error", error);
    }
  };
  // Get all Project list Api
  const getAllProjectData = async (sortdata: never[]) => {
    try {
      setIsLoading(true);
      if (sortdata.length > 0) {
        setProjectDataLength(sortdata.length);
        setProjectNameData(sortdata);
        setFilteredDataSource(sortdata);
      } else {
        try {
          let jsonValue = await AsyncStorage.getItem("userData");
          var userDetailsresponse = JSON.parse(jsonValue);

          var getProjectData = JSON.stringify({
            module: "project",
            // active: 1,
            user_id: userDetailsresponse.id,
            relation: [
              {
                module: "project_type",
              },
              {
                module: "project_devices",
                subModule: "devices_master",
              },
            ],
          });

          const ProjectNameResponse = await postData(
            getProjectData,
            "masters/getMasterList1", // change from getMasterList to getMasterList1
          );
          setIsLoading(false);
          var code = ProjectNameResponse.code;
          if (code == 1) {
            setProjectDataLength(ProjectNameResponse.data.length);
            setProjectNameData(ProjectNameResponse.data);
            setFilteredDataSource(ProjectNameResponse.data);

            // const results = jsonToCSV(ProjectNameResponse.data);
          } else {
            setIsLoading(false);
            //alert(ProjectNameResponse.message);
          }
        } catch (error) {
          setIsLoading(false);
        }
      }
    } catch (error) {
      console.error("Error", error);
    }
  };
  const sortFun = () => {
    const sortData = filterData.sort((item, b) =>
      item.Project_name.localeCompare(b.Project_name),
    );
    getAllProjectData(sort == 1 ? sortData : []);
    setFilteredDataSource(sortData);
  };

  const getProjectListForExport = async () => {
    setIsLoading(true);
    try {
      let jsonValue = await AsyncStorage.getItem("userData");
      var userDetailsresponse = JSON.parse(jsonValue);

      var stateData = JSON.stringify({
        modelName: "project",
        user_id: userDetailsresponse.id,
      });
      const projectDataResponse = await postData(
        stateData,
        "masters/dependentListExport",
      );
      setIsLoading(false);
      var code = projectDataResponse.code;
      if (code == 1) {
        setProjectListExport(projectDataResponse.data);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error", error);
    }
  };

  const downloadExcelReport = async () => {
    const filteredData = projectListExport.map(
      (
        {
          projectname,
          projecttype,
          contractor,
          omega,
          projectdetails,
          client,
          active,
        },
        index,
      ) => ({
        "Sr No": index + 1,
        "Project Name": projectname,
        "Project Type": projecttype,
        Contractor: contractor,
        "Omega Name": omega ? omega : "NA",
        "Project Details": projectdetails,
        Client: client,
        Active: active == 1 ? "Active" : "InActive",
      }),
    );
    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    const excelBuffer = XLSX.write(workbook, {
      type: "array",
      bookType: "xlsx",
    });
    const excelData = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(excelData, "project.xlsx");
  };

  const screenwidth = Dimensions.get("window").width;
  const isMobile = screenwidth < 768;

  return (
    <View style={styles.container}>
      <View
        style={
          isMobile
            ? { width: "100%", marginTop: 270 }
            : { flexDirection: "row", width: "100%", marginTop: "10%" }
        }
      >
        <View
          style={
            isMobile
              ? { margin: 10, marginTop: -45, height: 0, flex: 1 }
              : { flex: 1, margin: 10 }
          }
        >
          <Text style={styles.lableText}>Profile {">"} Project Profile</Text>
        </View>

        <Modal
          visible={editpopup}
          animationType={"slide"}
          transparent={true}
          onRequestClose={() => {
            setEditPopup(false);
          }}
        >
          <View
            style={
              isMobile
                ? {
                    backgroundColor: "white",
                    borderColor: "#eee",
                    borderRadius: 5,
                    alignSelf: "center",
                    borderWidth: 1,
                    // justifyContent: "center",
                    height: "25%",
                    margin: "auto",
                    padding: 10,
                    shadowOffset: {
                      width: 0,
                      height: 2,
                    },
                    shadowOpacity: 0.25,
                    shadowRadius: 4,
                    elevation: 5,
                    // marginRight: 10,
                    // marginRight: 1,
                    width: "60%",
                  }
                : [styles.contanerSwitch]
            }
          >
            <TouchableOpacity
              style={{ alignSelf: "flex-end" }}
              onPress={() => setEditPopup(false)}
            >
              <IconCross
                name="circle-with-cross"
                size={20}
                color="#000"
                style={{ bottom: 5, top: 0 }}
              />
            </TouchableOpacity>

            <Text style={[styles.tableHeader, { marginBottom: 20 }]}>
              Do You Want Update Status
            </Text>
            <View
              style={{
                flexDirection: "row",
                paddingRight: 10,
                justifyContent: "space-between",
              }}
            >
              <TouchableOpacity
                onPress={() => {
                  (setEditPopup(false), toggleSwitch());
                }}
                style={styles.saveBtn}
              >
                <Text style={{ color: "white" }}>Yes</Text>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={() => {
                  setEditPopup(false);
                }}
                style={styles.saveBtn}
              >
                <Text style={{ color: "white" }}>No</Text>
              </TouchableOpacity>
            </View>
          </View>
        </Modal>
        <View
          style={
            isMobile
              ? {
                  alignItems: "center",
                  marginTop: 20,
                  marginLeft: "-35%",
                  width: "170%",
                  flex: 2,
                }
              : { alignItems: "center", flex: 2 }
          }
        >
          <TextInput
            style={
              isMobile
                ? {
                    height: 35,
                    borderWidth: 2,
                    paddingLeft: 10,
                    borderColor: "#319ef0",
                    backgroundColor: "#FFFFFF",
                    width: "50%",
                    borderRadius: 5,
                    color: "#000",
                    fontWeight: "400",
                  }
                : styles.textInputStyle
            }
            onChangeText={(text) => searchFilterFunction(text)}
            value={searchData}
            underlineColorAndroid="transparent"
            underlineColor={"white"}
            placeholder="Search Project"
            theme={{
              colors: {
                text: "black",
                primary: "white",
                background: "transparent",
              },
            }}
            left={
              <TextInput.Icon
                name={() => <IconEdit name="search" size={20} color="#000" />} // where <Icon /> is any component from vector-icons or anything else
              />
            }
          />
        </View>
        <View style={{ flex: 1, alignItems: "flex-end" }}>
          <TouchableOpacity
            style={
              isMobile
                ? {
                    alignItems: "center",
                    backgroundColor: "#006EB9",
                    padding: 10,
                    borderWidth: 1,
                    borderColor: "#006EB9",
                    width: "35%",
                    // marginTop: 20,
                  }
                : styles.addDevice
            }
            onPress={() => {
              navigation.navigate("CreateProjectProfile");
            }}
          >
            <Text style={styles.btnText}>
              <Icon name="plus" size={15} color="#fff" /> Create
            </Text>
          </TouchableOpacity>
        </View>
      </View>
      <View style={{ flexDirection: "row", width: "100%" }}>
        <View style={{ flex: 1 }}>
          {/* <TouchableOpacity
            style={styles.addDevice}
            // onPress={() => isCreatable()}
          >
            <Text style={styles.btnText}>
              <Icon name="plus" size={15} color="#fff" /> Add Country
            </Text>
          </TouchableOpacity> */}
        </View>
      </View>

      <View
        style={
          isMobile
            ? {
                width: "100%",
                alignItems: "flex-end",
                marginTop: "-10%",
                marginLeft: "-120%",
              }
            : { width: "100%", alignItems: "flex-end" }
        }
      >
        <TouchableOpacity
          style={
            isMobile
              ? {
                  alignItems: "center",
                  backgroundColor: "#006EB9",
                  padding: 10,
                  borderWidth: 1,
                  borderColor: "#006EB9",
                  width: "45%",
                  marginRight: -10,
                }
              : {
                  alignItems: "center",
                  backgroundColor: "#006EB9",
                  padding: 10,
                  borderWidth: 1,
                  borderColor: "#006EB9",
                  width: "10%",
                }
          }
          onPress={() => {
            downloadExcelReport();
          }}
        >
          <Text style={styles.btnText}>
            <Icon name="exclefile1" size={15} color="#fff" /> Download
          </Text>
        </TouchableOpacity>
      </View>

      <View
        style={
          isMobile
            ? [styles.card, { flexGrow: 1, marginTop: 50, paddingBottom: 10 }]
            : [styles.card, { flexGrow: 1 }]
        }
      >
        <View
          style={[
            styles.shadowProp,
            {
              backgroundColor: "white",
            },
          ]}
        >
          <View
            style={{
              width: "100%",
              // flex: 1,
              backgroundColor: "#F6F9F9",
            }}
          >
            <View
              style={
                isMobile
                  ? {
                      borderWidth: 1,
                      borderColor: "#e3e0e0",
                      width: "110%",
                      alignSelf: "center",
                    }
                  : {
                      borderWidth: 1,
                      borderColor: "#e3e0e0",
                      width: "100%",
                      alignSelf: "center",
                    }
              }
            >
              <View>
                {isLoading ? (
                  <ActivityIndicator
                    color="#1DA1F2"
                    visible={isLoading}
                    textContent={"Loading..."}
                    size={80}
                  />
                ) : (
                  <DataTable
                    // title="Country"
                    columns={columns}
                    data={filterData}
                    customStyles={customStyles}
                    pagination
                  />
                )}
              </View>
              {/* prvider datatable code here */}

              {/* ended */}
            </View>
          </View>
          {/* </ScrollView> */}
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    padding: 20,
  },
  input: {
    borderColor: "gray",
    width: "60%",
    borderWidth: 1,
    borderRadius: 10,

    padding: 10,
  },
  tableHead: {
    fontSize: 14,
    /* FontFamily: 'Muli' ,*/
    fontWeight: "400",
    color: "#000",
  },
  addDevice: {
    alignItems: "center",
    backgroundColor: "#006EB9",
    padding: 10,
    borderWidth: 1,
    borderColor: "#006EB9",
    width: "50%",
    // marginTop: 20,
  },
  contanerSwitch: {
    backgroundColor: "white",
    borderColor: "#eee",
    borderRadius: 5,
    alignSelf: "center",
    borderWidth: 1,
    // justifyContent: "center",
    height: "25%",
    margin: "auto",
    padding: 10,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
    // marginRight: 10,
    // marginRight: 1,
    width: "30%",
  },
  saveBtn: {
    alignItems: "center",
    backgroundColor: "#006EB9",
    padding: 10,
    borderWidth: 1,
    borderColor: "#006EB9",
    width: "50%",
    marginRight: 10,
  },
  tableHeader: {
    color: "#000",
    fontSize: 14,
    /* FontFamily: 'Muli' ,*/
    fontWeight: "700",
  },
  title: {
    fontSize: 20,
    fontWeight: "bold",
  },
  btnText: {
    color: "#fff",
    fontWeight: "600",
  },
  card: {
    width: "100%",
    flex: 1,
    marginVertical: 10,
  },
  shadowProp: {
    shadowColor: "#171717",
    shadowOffset: { width: -2, height: 4 },
    shadowOpacity: 0.2,
    shadowRadius: 25,
  },
  link: {
    marginTop: 15,
    paddingVertical: 15,
  },
  linkText: {
    fontSize: 14,
    color: "#2e78b7",
  },
  textInputStyle: {
    height: 40,
    borderWidth: 2,
    paddingLeft: 10,
    margin: 5,
    borderColor: "#319ef0",
    backgroundColor: "#FFFFFF",
    width: "40%",
    borderRadius: 5,
    color: "#000",
    fontWeight: "400",
  },
  lableText: {
    color: "#484848",
    fontWeight: "700",
    marginTop: 18,
    // fontSize: 21,
  },
});
